import { CircleMemberProvider } from '@/circle/contexts/CircleMemberProvider'
import DbOrgProvider from '@/org/contexts/DbOrgProvider'
import { useOrgRouteParams } from '@/org/hooks/useOrgRouteParams'
import React from 'react'
import TopBanners from './TopBanners'
import LoggedContent from './LoggedContent'

interface Props {
  children: React.ReactNode
}

// 🔑 Les bandeaux (impersonation, annonce, nouvelle version) vivent ICI, et pas
// dans SuperAdminLayout : ce dernier ne couvre que /admin, or on incarne
// quelqu'un précisément pour aller voir SON application, et une annonce vaut
// pour toutes les pages. LoggedLayout enveloppe tout l'espace authentifié,
// c'est le seul endroit d'où un bandeau suit la personne partout.
export default function LoggedLayout({ children }: Props) {
  const { orgId, slug } = useOrgRouteParams()

  // Database-backed org data and edit actions, available everywhere (sidebar,
  // graph, role panel, global circle modal). The proposal editor overrides this
  // locally with an in-memory draft.
  return (
    <DbOrgProvider orgId={orgId} slug={slug}>
      <CircleMemberProvider>
        <TopBanners>
          <LoggedContent>{children}</LoggedContent>
        </TopBanners>
      </CircleMemberProvider>
    </DbOrgProvider>
  )
}
